<template>
  <div class="w-full flex flex-wrap">
    <div class="w-full md:w-1/2 flex-none md:flex-col pt-8">
      <div class="pt-6">
        <router-link :to="{ name: '' }" class="inline-block align-middle">
          <img
            class="object-center h-24"
            :src="`${publicPath}images/apple-touch-icon.png`"
            alt="Moria"
          />
        </router-link>
        <router-view />
      </div>
    </div>
    <div class="w-full md:w-1/2 flex-none bg-gray-400 pt-8">
      <div class="p-8 w-full h-screen text-3xl">
        Use this side for Adds or interesting messages.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  }
};
</script>
